import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ShopifyConfirmScreen = lazy(
  () => import('~/features/item-setup/pages/shopify-confirm-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/shopify-confirm')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ShopifyConfirmScreen />
    </Suspense>
  ),
});
